// extracted by mini-css-extract-plugin
export var bgPurple = "main-module--bg-purple--59cbc";
export var mainBtn = "main-module--main-btn--27fc1";
export var mainBtnRound = "main-module--main-btn-round--aa4d9";
export var mainTitle = "main-module--main-title--13cd5";
export var pt = "main-module--pt--ee249";